import React, { FC, useState } from 'react';
import { Typography, TextField, FormHelperText, RadioGroup, Radio, FormControlLabel } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';
import { ptBR } from 'date-fns/locale';
import clsx from 'clsx';
import { stylesCalculator } from '../../styles/calculator';
import { Contribution } from '../../components/App';
import { getCommon } from '../../styles/common';

interface CalculatorProps {
    inputType: 'time' | 'picker';
    contributions: Contribution[];
    errorMessageTotalTime: string;
    years: string;
    months: string;
    handleChangeYears: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeMonths: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeInputType: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleContributionChange: (date: Date | null, index: number, type: 'begin' | 'end') => void;
}

const ContributionInput: FC<CalculatorProps> = (props: CalculatorProps) => {
    const classes = stylesCalculator();
    const common = getCommon();
    const [update, forceUpdate] = useState(0);
    const {
        inputType,
        years,
        months,
        errorMessageTotalTime,
        handleChangeYears,
        handleChangeMonths,
        handleChangeInputType,
        handleContributionChange,
    } = props;
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDay());
   
    const addPeriod = () => {
        props.contributions.push({ begin: null, end: null });
    };

    const removePeriod = (index: number) => {
        props.contributions.splice(index, 1);
    };
    return (
        <div className={classes.container}>
            <Typography className={classes.title} align={'center'} variant="h4" component="p">
                Período de Contribuição
            </Typography>
            <RadioGroup
                aria-label="gender"
                name="gender1"
                className={classes.radioContainer}
                value={inputType}
                onChange={handleChangeInputType}
                color={common.colors.primary()}
            >
                <FormControlLabel value="time" control={<Radio />} label="Tempo" labelPlacement="start" />
                <FormControlLabel value="picker" control={<Radio />} label="Datas" labelPlacement="start" />
                
            </RadioGroup>
            {inputType === 'time' ? (
                <>
                <Typography className={clsx(classes.subtitle)} align={'center'} variant="h6" component="p">
                    Tempo Total
                </Typography>
                <div className={classes.contributionContainer}>
                    <div className={classes.contributionTextContainer}>
                        <TextField
                            className={classes.inputContribution}
                            type="number"
                            onChange={handleChangeYears}
                            value={years}
                        />
                        <Typography
                            className={classes.inputContributionText}
                            align={'center'}
                            variant="h6"
                            component="span"
                        >
                            anos
                        </Typography>
                    </div>
                    <div className={classes.contributionTextContainer}>
                        <TextField
                            className={classes.inputContribution}
                            type="number"
                            value={months}
                            onChange={handleChangeMonths}
                        />
                        <Typography
                            className={classes.inputContributionText}
                            align={'center'}
                            variant="h6"
                            component="span"
                        >
                            meses
                        </Typography>
                    </div>
                </div>
            </>

            ) : (
                props.contributions.map((contribution: Contribution, index) => (
                <div key={'period-' + index}>
                    <Typography className={clsx(classes.subtitle)} align={'center'} variant="h6" component="p">
                        {'Período ' + (index + 1)}
                    </Typography>
                    <div className={classes.periodButtons}>
                        <span
                            onClick={() => {
                                removePeriod(index);
                                forceUpdate(update + 1);
                            }}
                            className={clsx(index === 0 && classes.hide, classes.deleteButton)}
                        >
                            -
                        </span>
                        <span
                            onClick={() => {
                                addPeriod();
                                forceUpdate(update + 1);
                            }}
                            className={clsx(
                                props.contributions.length - 1 > index && classes.hide,
                                classes.addButton
                            )}
                        >
                            +
                        </span>
                    </div>
                    <div className={classes.contributionContainer}>
                        <div className={classes.contributionTextContainer}>
                            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={clsx(classes.calendarInputContribution)}
                                    margin="none"
                                    format="dd/MM/yyyy"
                                    value={props.contributions[index].begin}
                                    onChange={(date: Date | null) => {
                                        handleContributionChange(date, index, 'begin');
                                        forceUpdate(update + 1);
                                    }}
                                    invalidDateMessage="Data em formato inválido."
                                    minDate={minDate}
                                    minDateMessage={`A data deve ser maior que ${dayjs(minDate).format(
                                        'DD/MM/YYYY'
                                    )}.`}
                                    cancelLabel="Cancelar"
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className={classes.contributionTextContainer}>
                            <Typography
                                className={classes.calendarText}
                                align={'center'}
                                variant="h6"
                                component="span"
                            >
                                -
                            </Typography>
                            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.calendarInputContribution}
                                    margin="none"
                                    format="dd/MM/yyyy"
                                    value={props.contributions[index].end}
                                    onChange={(date: Date | null) => {
                                        handleContributionChange(date, index, 'end');
                                        forceUpdate(update + 1);
                                    }}
                                    invalidDateMessage="Data em formato inválido."
                                    minDate={minDate}
                                    minDateMessage={`A data deve ser maior que ${dayjs(minDate).format(
                                        'DD/MM/YYYY'
                                    )}.`}
                                    cancelLabel="Cancelar"
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                </div>
            ))

            )}
            <FormHelperText className={clsx(errorMessageTotalTime === '' && classes.hide, classes.errorText)}>
                {errorMessageTotalTime}
            </FormHelperText>
        </div>
    );
};

export default ContributionInput;
